module.exports = __webpack_public_path__ + "static/media/Gallery14.19918b46.jpg";